import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import { Spacer } from 'components/Utility'
import { addMonths, isSameMonth } from 'date-fns'

type Props = {
  currentMonth: Date
  handleCurrentMonth: (date: Date) => void
  label: string
  type: 'prev' | 'next'
}

const StockCalendarArrowButton: FC<Props> = React.memo((props) => {
  const { currentMonth, handleCurrentMonth, label, type } = props

  const selectedMonth = type === 'prev' ? addMonths(currentMonth, -1) : addMonths(currentMonth, 1)

  const className = type === 'prev' ? styles.button__arrow_monthly_prev : styles.button__arrow_monthly_next

  return (
    <button
      className={className}
      disabled={type === 'prev' && isSameMonth(currentMonth, new Date())}
      onClick={() => handleCurrentMonth(selectedMonth)}
    >
      {type === 'prev' ? (
        <>
          <img src={`/icon/arrow_${type}.svg`} alt={label} width={20} height={20} />
          <Spacer size={8} axis={'horizontal'} />
          {label}
        </>
      ) : (
        <>
          {label}
          <Spacer size={8} axis={'horizontal'} />
          <img src={`/icon/arrow_${type}.svg`} alt={label} width={20} height={20} />
        </>
      )}
    </button>
  )
})

export default StockCalendarArrowButton
